import { useEffect, useState } from "react";
import { base44 } from "@/api/base44Client";
import { useSeo } from "@/hooks/useSeo";

// Hook que combina useSeo con la imagen destacada IA de la página (entidad
// SeoImage, clave por ruta). Busca la imagen para `route`; si existe la usa
// como og:image/twitter:image al compartir el enlace. Si no existe o falla,
// deja que useSeo use su imagen por defecto (o la pasada en seoOpts.image).
//
// Uso: reemplaza `useSeo({ title, description, ... })` por
//      `usePageSeoImage("/ruta", { title, description, ... })`.
export function usePageSeoImage(route, seoOpts) {
  const [img, setImg] = useState(seoOpts?.image);
  useEffect(() => {
    if (!route) return;
    let alive = true;
    base44.entities.SeoImage.filter({ route, active: true }, { limit: 1, fields: ["image_url"] })
      .then((page) => {
        if (!alive) return;
        const url = page?.items?.[0]?.image_url;
        if (url) setImg(url);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [route]);
  useSeo({ ...seoOpts, ...(img ? { image: img } : {}) });
}